module.exports = __webpack_public_path__ + "img/mb-google-dr-1.7954b977.jpg";